<template>
  <div class="mt-3 w-100">
    <PayDetail>
      <template #title>Tổng tiền ({{ itemPos.listItemCart.length }} sản phẩm)</template>
      <template #price>{{ formatMoneyNotUnitExt(itemPos.totalAmountCart) }} đ</template>
    </PayDetail>

    <PayDetail hasPopover :disabled="itemPos.totalAmountCart == 0">
      <template #title>
        <el-tooltip class="item" effect="light" placement="top-start">
          <div slot="content">Thuế tổng đơn sẽ áp dụng cho<br />toàn đơn hàng và xoá đi các <br />thay đổi về thuế của sản phẩm<br />riêng lẻ</div>
          <div>
            Thuế tổng đơn
          </div>
        </el-tooltip>
      </template>
      <template #price>{{ formatMoneyNotUnit(Math.floor((itemPos.taxOrder / 100) * itemPos.totalAmountCart)) }} đ</template>
      <template #popover>
        <div class="row d-flex align-items-center">
          <div class="col-4 text-right">Thuế tổng đơn (%):</div>
          <div class="col-8">
            <input
              @keydown="allowNumbersOnlyAndMoveKey"
              class="form-control"
              type="number"
              v-model.number="itemPos.taxOrder"
              :min="0"
              :max="100"
              @input="() => {CheckMinMax(itemPos, 'taxOrder', 0, 100), changeTaxOrder()}"
            />
          </div>
        </div>
      </template>
    </PayDetail>

    <PayDetail hasPopover>
      <template #title>Chiết khấu</template>
      <template #price
        >{{
          itemPos.selecTypeInput == "đ" ? formatMoneyNotUnit(itemPos.discountOrder) : formatMoneyNotUnit(Math.floor((itemPos.discountOrder / 100) * itemPos.totalAmountCart))
        }}
        đ</template
      >
      <template #popover>
        <div class="row d-flex align-items-center">
          <div class="col-4 text-right">Chiết khấu:</div>
          <div class="col-8">
            <InputMoneyOption class="mb-2" v-model="discountOption"></InputMoneyOption>
          </div>
        </div>
      </template>
    </PayDetail>

    <PayDetail hasPopover :disabled="itemPos.totalAmountCart == 0">
      <template #title>Phí dịch vụ</template>
      <template #price>{{ formatMoneyNotUnit(itemPos.ortherService) }} đ</template>
      <template #popover>
        <div class="row d-flex align-items-center">
          <div class="col-4 text-right">Phí dịch vụ:</div>
          <div class="col-8">
            <input @keydown="allowNumbersOnlyAndMoveKey" class="form-control" v-model.number="itemPos.ortherService" :min="0" />
          </div>
        </div>
      </template>
    </PayDetail>

    <PayDetail>
      <template #title>Tổng tiền</template>
      <template #price
        ><b>{{ formatMoneyNotUnitExt(Math.ceil(cashCharged)) }} đ</b></template
      >
    </PayDetail>
  </div>
</template>

<script>
import PayDetail from "./payDetail.vue";
import InputMoneyOption from "../../V2/pos/components/InputMoneyOption.vue";

import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    datas: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { PayDetail, InputMoneyOption },
  data() {
    return {
      discountOption: {
        type: "%",
        "%": 0,
        đ: 0,
      },
    };
  },
  methods: {
    ...mapMutations("ordersReturn", ["setReturnPrice", "setExchangePrice"]),
    CheckMinMax(parent, key, min, max) {
      if (parent[key] <= min) parent[key] = +min;
      else if (parent[key] >= max) parent[key] = +max;
    },
    changeTaxOrder() {
      this.itemPos.listItemCart.map((item) => {
        item.tax = 0;
      });
    },
  },
  computed: {
    ...mapGetters("sell", ["getRmId"]),
    itemPos: {
      get() {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1;
        if (index == -1) {
          index = 0;
          this.SET_RM_ID(index);
        }
        return this.datas.orders[index];
      },
      set(newValue) {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1;
        if (index == -1) {
          index = 0;
          this.SET_RM_ID(index);
        }
        this.datas.orders[index] = newValue;
      },
    },

    discountOrder1() {
      if (this.itemPos.selecTypeInput == "%") {
        return this.itemPos.discountOrder ? (this.itemPos.discountOrder * this.itemPos.totalAmountCart) / 100 : 0;
      } else {
        return this.itemPos.discountOrder ? this.itemPos.discountOrder : 0;
      }
    },
    taxOrder1() {
      const total_real = this.itemPos.totalAmountCart - this.discountOrder1;
      return Math.ceil((total_real * this.itemPos.taxOrder) / 100);
    },
    addFeesShippingAmount() {
      if (this.itemPos.isDiliveryLast) {
        return this.itemPos.dloInfo.addFeesShipping.amount ? this.itemPos.dloInfo.addFeesShipping.amount : 0;
      } else {
        return 0;
      }
    },
    cashCharged() {
      return Math.ceil(this.itemPos.totalAmountCart - this.discountOrder1 + this.itemPos.ortherService + this.taxOrder1 + this.addFeesShippingAmount);
    },
  },
  watch: {
    discountOption: {
      handler() {
        const type = this.discountOption.type;
        const value = this.discountOption[type];
        this.itemPos.discountOrder = value;
        this.itemPos.selecTypeInput = type;
      },
      deep: true,
    },
    cashCharged: {
      handler() {
        this.setExchangePrice(this.cashCharged);
      },
      immediate: true,
    },
  },
};
</script>

<style></style>
